import ReadOnlyField from './ReadOnlyField'

export default ReadOnlyField
